import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";

function Media(props) {
  const { loading = false } = props;

  return (
    <Grid container wrap="nowrap">
      <Box sx={{ width: "100%", marginRight: 0.5, my: 4 }}>
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={128}
          sx={{ bgcolor: "grey.500" }}
        />
        <Box sx={{ pt: 0.5 }}>
          <Skeleton sx={{ bgcolor: "grey.500" }} />
          <Skeleton width="60%" sx={{ bgcolor: "grey.500" }} />
        </Box>
      </Box>
    </Grid>
  );
}

export default function SessionLoader() {
  return (
    <Box sx={{ overflow: "hidden" }}>
      <Media loading />
    </Box>
  );
}
